/**
 * ModalFormHeader — lightweight header for modal-embedded forms (CModel,
 * MUI Dialog content). Use INSTEAD of <PaperFormHeader> when the form is
 * already inside a Dialog wrapper that provides the frame.
 *
 * Pattern: overline label + larger title + optional secondary action slot
 * + thin divider. No status pill / number / date column (modals are
 * usually create-mode and short-lived).
 */

import React from "react";
import { Box, Stack, Typography, Divider } from "@mui/material";
import { DescriptionOutlined } from "@mui/icons-material";

export default function ModalFormHeader({
  overline,         // e.g. "SFM · Permission"
  title,            // e.g. "Add Permission"
  icon,             // optional MUI icon component (default DescriptionOutlined)
  rightSlot,        // optional React node rendered right-aligned (e.g. a Switch)
  showDivider = true,
}) {
  const Icon = icon || DescriptionOutlined;
  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
        sx={{ mb: 2 }}
      >
        <Box>
          {overline && (
            <Stack direction="row" alignItems="center" spacing={0.75} sx={{ mb: 0.25 }}>
              <Icon fontSize="small" sx={{ color: "text.secondary" }} />
              <Typography
                variant="overline"
                sx={{
                  letterSpacing: "0.12em",
                  color: "text.secondary",
                  fontWeight: 700,
                  lineHeight: 1.2,
                }}
              >
                {overline}
              </Typography>
            </Stack>
          )}
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, letterSpacing: "-0.005em", lineHeight: 1.2 }}
          >
            {title}
          </Typography>
        </Box>
        {rightSlot && <Box>{rightSlot}</Box>}
      </Stack>
      {showDivider && <Divider sx={{ mb: 2.5 }} />}
    </>
  );
}
